import { DismissTextButton } from './parts';
import { BORDER_OUTLINED_NEUTRAL, COLOR_BORDER_ASSISTIVE, FONT_FAMILY, Gray50, Gray700, Gray900, RADIUS_LG, RADIUS_SM, Red400, SHADOW_DIALOG, SP, Violet500, White } from './tokens';
import type { PopupCardContent } from './types';
import { toSafeOpenUrl } from './utils';
export function CenterModalCard({
  content,
  onClose,
  onButtonClick,
  onDismiss
}: {
  content: PopupCardContent;
  onClose?: () => void;
  onButtonClick?: (index: number, url?: string) => void;
  onDismiss?: () => void;
}) {
  const handleClose = () => {
    onDismiss?.();
    onClose?.();
  };
  const handleButtonClick = (index: number, url?: string) => {
    onButtonClick?.(index, url);
    // BottomRight 카드와 동일하게 http(s)/상대 경로만 연다. javascript:/data: 차단.
    const safeUrl = url ? toSafeOpenUrl(url) : null;
    if (safeUrl) {
      window.open(safeUrl, '_blank', 'noopener,noreferrer');
    }
    onClose?.();
  };
  const buttons = content.buttons;
  return <div style={{
    position: 'relative',
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    width: 'calc(100vw - 48px)',
    maxWidth: '960px',
    backgroundColor: White,
    borderRadius: RADIUS_LG,
    boxShadow: SHADOW_DIALOG,
    fontFamily: FONT_FAMILY,
    color: Gray900,
    overflow: 'hidden'
  }} data-sentry-component="CenterModalCard" data-sentry-source-file="CenterModalCard.tsx">
      <div style={{
      flex: '1 1 0',
      minWidth: '360px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      gap: '32px',
      padding: '40px'
    }}>
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: SP.md,
        width: '100%'
      }}>
          <NewBadge data-sentry-element="NewBadge" data-sentry-source-file="CenterModalCard.tsx" />
          {content.title && <div style={{
          fontSize: '30px',
          fontWeight: 800,
          lineHeight: '39px',
          color: Gray900,
          width: '100%',
          whiteSpace: 'pre-line'
        }}>
              {content.title}
            </div>}
          {content.body && <div style={{
          fontSize: '16px',
          fontWeight: 500,
          lineHeight: '22.4px',
          color: Gray700,
          width: '100%',
          whiteSpace: 'pre-line'
        }}>
              {content.body}
            </div>}
        </div>

        {buttons.length > 0 && <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: SP.xs,
        width: '100%'
      }}>
            {buttons.map((button, index) => <DialogButton key={`dialog-btn-${index}`} kind={index === 0 ? 'strong' : 'outlined'} label={button.label} onClick={() => handleButtonClick(index, button.url)} />)}
          </div>}

        <DismissTextButton dismissText={content.dismissText} onDismiss={onDismiss} onClose={onClose} data-sentry-element="DismissTextButton" data-sentry-source-file="CenterModalCard.tsx" />
      </div>

      {content.imageUrl && <div style={{
      width: '460px',
      height: '560px',
      overflow: 'hidden',
      position: 'relative',
      flexShrink: 1,
      backgroundColor: Gray50
    }}>
          <img src={content.imageUrl} alt={content.title} style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        pointerEvents: 'none'
      }} />
        </div>}

      <DialogCloseButton onClick={handleClose} data-sentry-element="DialogCloseButton" data-sentry-source-file="CenterModalCard.tsx" />
    </div>;
}
function NewBadge() {
  return <div style={{
    display: 'inline-flex',
    alignItems: 'center',
    border: `2px solid ${White}`,
    borderRadius: '999px'
  }} data-sentry-component="NewBadge" data-sentry-source-file="CenterModalCard.tsx">
      <div style={{
      backgroundColor: Red400,
      border: `1px solid ${COLOR_BORDER_ASSISTIVE}`,
      borderRadius: '32px',
      minHeight: '26px',
      padding: `0 ${SP.xs}`,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
        <span style={{
        fontSize: '13px',
        fontWeight: 600,
        lineHeight: '18.2px',
        color: White
      }}>
          New
        </span>
      </div>
    </div>;
}
function DialogButton({
  kind,
  label,
  onClick
}: {
  kind: 'strong' | 'outlined';
  label: string;
  onClick: () => void;
}) {
  const isStrong = kind === 'strong';
  return <button type="button" onClick={onClick} style={{
    height: '40px',
    minWidth: '40px',
    padding: `0 ${SP.sm}`,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: SP['3xs'],
    borderRadius: RADIUS_SM,
    fontFamily: FONT_FAMILY,
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '19.6px',
    cursor: 'pointer',
    backgroundColor: isStrong ? Violet500 : 'transparent',
    color: isStrong ? White : Gray700,
    border: isStrong ? 'none' : `1px solid ${BORDER_OUTLINED_NEUTRAL}`,
    whiteSpace: 'nowrap',
    transition: 'background-color 0.15s'
  }} data-sentry-component="DialogButton" data-sentry-source-file="CenterModalCard.tsx">
      {label}
    </button>;
}
function DialogCloseButton({
  onClick
}: {
  onClick: () => void;
}) {
  return <button type="button" onClick={onClick} aria-label="닫기" style={{
    position: 'absolute',
    top: '16px',
    right: '16px',
    width: '36px',
    height: '36px',
    minWidth: '36px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: Gray50,
    border: `1px solid ${COLOR_BORDER_ASSISTIVE}`,
    borderRadius: '999px',
    cursor: 'pointer',
    padding: 0,
    zIndex: 1
  }} data-sentry-component="DialogCloseButton" data-sentry-source-file="CenterModalCard.tsx">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" data-sentry-element="svg" data-sentry-source-file="CenterModalCard.tsx">
        <path d="M6 6L18 18M6 18L18 6" stroke={Gray700} strokeWidth="2" strokeLinecap="round" data-sentry-element="path" data-sentry-source-file="CenterModalCard.tsx" />
      </svg>
    </button>;
}